import "./design-system/colorVars/installColorVars";
import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { applyFeatureFlagUrlOverrides } from "./utils/featureFlags";

/**
 * ResizeObserver loop warnings are benign with React Flow / layout observers.
 * CRA dev overlay treats them as fatal; production builds never include that overlay.
 */
const RESIZE_OBSERVER_ERROR =
  /^ResizeObserver loop (completed with undelivered notifications|limit exceeded)/;

const isBenignResizeObserverMessage = (message: unknown): boolean =>
  typeof message === "string" && RESIZE_OBSERVER_ERROR.test(message);

if (process.env.NODE_ENV === "development" && typeof ResizeObserver !== "undefined") {
  const NativeResizeObserver = ResizeObserver;
  window.ResizeObserver = class PatchedResizeObserver extends NativeResizeObserver {
    constructor(callback: ResizeObserverCallback) {
      super((entries, observer) => {
        window.requestAnimationFrame(() => callback(entries, observer));
      });
    }
  };
}

window.addEventListener(
  "error",
  (event) => {
    if (isBenignResizeObserverMessage(event.message)) {
      event.stopImmediatePropagation();
      event.preventDefault();
    }
  },
  true,
);

// Flag switches (query params) must persist before the first render because flags are
// read synchronously; the retired `newAuth` param and the `/v1` / `/v2` entry links are
// rewritten out of the URL.
const entryUrl = applyFeatureFlagUrlOverrides(window.location);
if (entryUrl !== null) {
  window.history.replaceState(window.history.state, "", entryUrl);
}

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
